import React from "react";
import { selectSlot, selectMentees, appMentor } from "./actions";
import { useQueryWithStore, useQuery } from "react-admin";
import { useDispatch, useSelector } from "react-redux";
import Parse from "parse";
import { useCallback } from "react";
// import { useState } from "react";
import { useParams } from "react-router";

export const useMentorProfileData = (mid) => {
  const mentorData = useQueryWithStore({
    type: "getOne",
    resource: "User",
    payload: {
      id: mid,
    },
  });
  return mentorData;
};

export const useMentorAvailabilityData = (aid, duration) => {
  const { mentorId } = useParams();
  const availabilityData = useQueryWithStore({
    type: "getOne",
    resource: "Availability",
    payload: {
      id: aid,
    },
  });
  const appointmentData = useQuery({
    type: "getList",
    resource: "Appointment",
    payload: {
      filter: {},
      pagination: { page: 1, perPage: 1000 },
      sort: { field: "id", order: "DSC" },
    },
  });

  appointmentData.data = appointmentData.loaded
    ? appointmentData.data.filter((value) => value.mentor.id === mentorId)
    : [];

  return {
    availabilityData,
    appointmentData,
  };
};

export const useEmailForUser = () => {
  async function getEmail(email) {
    const User = Parse.User;
    let qry = new Parse.Query(User);
    qry.equalTo("role", "user");
    qry.equalTo("email_", email);
    qry.select("id");

    const resp = await qry.find();
    return resp;
  }

  return { getEmail };
};

export const useIdforUser = (id) => {
  const usrData = useQueryWithStore({
    type: "getOne",
    resource: "User",
    payload: {
      role: "user",
      id: id,
    },
  });

  return usrData;
};

export const useSelectedSlot = () => {
  const dispatch = useDispatch();
  const selectedSlot = useCallback((slot) => dispatch(selectSlot(slot)), [
    dispatch,
  ]);
  return { selectedSlot };
};

export const useSelectedMentees = () => {
  const dispatch = useDispatch();
  const selectedMentees = useCallback(
    (mentees) => dispatch(selectMentees(mentees)),
    [dispatch]
  );
  return { selectedMentees };
};

export const useSelectedMentor = () => {
  const dispatch = useDispatch();
  const selectedMentor = useCallback((mentor) => dispatch(appMentor(mentor)), [
    dispatch,
  ]);
  return { selectedMentor };
};

export const useAppointmentData = () => {
  const appointment = useSelector((state) => state.appointment);
  return appointment;
};


export const useAppointmentCreator = () => {
  const [appointment] = React.useState({
    loading: true,
    loaded: false,
    data: null,
    error: null,
  });

  const _a = useAppointmentData();
  async function commitAppointment(totalBill) {
    const makePayment = await Parse.Cloud.run("makePayment", {
      opration: "MakePayment",
      totalBill: totalBill,
      userDetails: _a,
    });
    const AppointmentResponse = await Parse.Cloud.run("CreateAppointment", {
      AppointmentData: _a,
      makePayment: makePayment,
    });
    if (AppointmentResponse[0] === true) {
      window.open(makePayment.Payment, "_self");
    }
  }
  return [appointment, commitAppointment];
};

